import { Controller } from '@hotwired/stimulus';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static targets = ['formContainer', 'currentlyPausedContainer', 'scheduledPauseContainer'];

    showForm() {
        this.formContainerTarget.classList.remove('d-none');

        if (this.hasCurrentlyPausedContainerTarget) {
            this.currentlyPausedContainerTarget.classList.add('d-none');
        }

        if (this.hasScheduledPauseContainerTarget) {
            this.scheduledPauseContainerTarget.classList.add('d-none');
        }
    }

    cancelPause(event) {
        event.preventDefault();

        showPreloader();

        fetch(routes['app_accountsettings_cancelpause'])
            .then((response) => {
                if (!response.status) {
                    hidePreloader();
                    addAlert('danger', response.message || translations['profile.An unknown error occurred.']);

                    return;
                }

                return response;
            })
            .then((response) => response.json())
            .then((data) => {
                if (data.status) {
                    window.location.reload();
                }
            });
    }
}
